import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdatePartnerOrderInstructionsInterface {
  partnerOrderid?: string
  warehouseOrderNo?: string
  orderInstructions?: string
}

export const useUpdatePartnerOrderInstructions = () => {
  const mutate = useMutation(
    ({
      partnerOrderid,
      warehouseOrderNo,
      orderInstructions,
    }: UpdatePartnerOrderInstructionsInterface) => {
      return putAPI('/PartnerOrder/Instructions', {
        partnerOrderid: partnerOrderid,
        warehouseOrderNo: warehouseOrderNo,
        OrderInstructions: orderInstructions,
      })
    },
  )

  return mutate
}

export default useUpdatePartnerOrderInstructions
